import { render, staticRenderFns } from "./view_report.vue?vue&type=template&id=61f5f537&scoped=true&"
import script from "./view_report.vue?vue&type=script&lang=js&"
export * from "./view_report.vue?vue&type=script&lang=js&"
import style0 from "./view_report.vue?vue&type=style&index=0&id=61f5f537&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f5f537",
  null
  
)

export default component.exports